<template>
  <a href="/ielts" style="text-decoration:none">
    <h2 :style="`color: ${color}`">
      IELTS
    </h2>
    <span class="toefl-r" :style="`color: ${color}`">
      &reg;
    </span>
    <h2 :style="`color: ${color}`">Mocks</h2>
  </a>
</template>

<script>
export default {
  props: ["color"]
};
</script>

<style scoped>
h2 {
  display: inline-block;
  color: var(--themeColor);
  line-height: 60px;
  margin: 0;
  font-weight: 700;
}

.toefl-r {
  font-weight: 700;
  font-size: 22px;
  display: inline-block;
  vertical-align: top;
  padding-top: 10px;
  margin-right: 5px;
}
</style>
